import React, {Component} from 'react';

class FormTitle extends Component {
  render() {
    return(
      <div className="w3-container w3-padding-16 custom-container-title" style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <p className="custom-title-form">Daftar sekarang dalam 3 cara mudah..</p>
      </div>
    )
  }
}

export default FormTitle;



// WEBPACK FOOTER //
// ./src/component/Home/Content/form_title.js